import { j as s } from "../../../../jsx-runtime-BwWtxLpl.js";
import { useContext as r } from "react";
import e from "prop-types";
import { SelectCheckbox as i } from "../checkbox/checkbox.js";
import { SelectContext as n } from "../select-context.js";
const p = ({ i18n: t = { deselect: "Deselect All", select: "Select All" } }) => {
  const {
    hasSelectedAllOptions: { selected: l, indeterminate: o },
    handleClickSelectAll: c
  } = r(n);
  return /* @__PURE__ */ s.jsxs("div", { className: "motif-select-all", onClick: c, children: [
    /* @__PURE__ */ s.jsx(i, { selected: l, indeterminate: o }),
    l ? t.deselect : t.select
  ] });
};
p.propTypes = {
  i18n: e.shape({
    deselect: e.string,
    select: e.string
  }).isRequired
};
export {
  p as SelectAllOptions
};
